<script lang="ts" setup>
import type { LinkGroup } from '.';
import type { SectionName } from '~/types/mixpanel';

import { LinkingSection } from '@/components/Sections/LinkingSection';
import { useEvents } from '@/composables/events/useEvents';
import { useLogger } from '~/composables/useLogger';

import { curitibaGroups, saoPauloGroups } from '.';

const logger = useLogger('NeighborhoodLinkingSection');

const { sectionName = 'pre-footer', currentPage = 'Home' } = defineProps<{
	sectionName?: SectionName;
	currentPage?: string;
}>();

const tabs = ['São Paulo', 'Curitiba'] as const;

type CityTab = (typeof tabs)[number];

const selectedTab = ref<CityTab>('São Paulo');

const groups = computed<LinkGroup[]>(() =>
	selectedTab.value === 'São Paulo' ? saoPauloGroups : curitibaGroups
);

const { trackLinkClicked } = useEvents();

const linkCategory = 'Tipos de imóvel por Bairro';

function handleTabUpdate(tab: string) {
	if ((tabs as readonly string[]).includes(tab)) {
		selectedTab.value = tab as CityTab;
	} else {
		logger.error(`Invalid tab value received: ${tab}`);
	}
}

function handleLinkClick(item: LinkGroup['items'][number]) {
	trackLinkClicked({
		current_page: currentPage,
		section_name: sectionName,
		destination_url: item.href,
		click_city: selectedTab.value,
		link_category: linkCategory,
		link_text: item.label
	});
}
</script>

<template>
	<LinkingSection
		title="Tipos de imóvel por Bairro"
		:tabs="tabs"
		:selected-tab="selectedTab"
		:groups="groups"
		layout-id="tab-underline"
		bg-class="bg-white-dark-1"
		@update:selected-tab="handleTabUpdate"
		@link-click="handleLinkClick"
	/>
</template>
